/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { useState, useEffect, useRef } from 'react';

const useMonitoringSocket = () => {
  const [connections, setConnections] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const socket = useRef(null);

  useEffect(() => {
    const url = import.meta.env.VITE_MONITORING_WEBSOCKET_URL;
    if (!url) {
      console.error('VITE_MONITORING_WEBSOCKET_URL is not defined in .env');
      return;
    }

    socket.current = new WebSocket(url);

    socket.current.onopen = () => {
      console.log('Monitoring socket connected');
      setIsConnected(true);
    };

    socket.current.onmessage = (event) => {
      console.log('Received data from monitoring socket:', event.data);
      const data = JSON.parse(event.data);
      if (data.type === 'connection_update') {
        setConnections(data.connections);
      }
    };

    socket.current.onclose = (event) => {
      console.error('Monitoring socket closed unexpectedly:', event);
      setIsConnected(false);
      // Server redeploying — reconnect immediately
      if (event.code === 4000) {
        console.log('[MonitoringSocket] Server redeploying, reconnecting immediately...');
      }
    };

    socket.current.onerror = (error) => {
      console.error('Monitoring socket error:', error);
      setIsConnected(false);
    };

    return () => {
      if (socket.current) {
        socket.current.close();
      }
    };
  }, []);

  return { connections, isConnected };
};

export default useMonitoringSocket;
